/**
 * Mooncloak Search Result Mockup
 * Simulates how an ad appears in Mooncloak search results
 */

import React from 'react';
import { Shield, Search } from 'lucide-react';

interface MooncloakSearchMockupProps {
  children: React.ReactNode;
  adWidth: number;
  adHeight: number;
}

export function MooncloakSearchMockup({ children, adWidth, adHeight }: MooncloakSearchMockupProps) {
  const isLeaderboard = adWidth > adHeight * 3;
  const isSidebar = adHeight > adWidth;

  return (
    <div className="bg-[#0a0e17] rounded-xl overflow-hidden shadow-2xl w-full max-w-[600px]">
      {/* Header */}
      <div className="bg-[#111428] px-4 py-3 flex items-center gap-3 border-b border-white/10">
        <Shield className="w-6 h-6 text-[#FFE17D]" />
        <span className="text-white font-semibold text-sm">mooncloak</span>
        <div className="flex-1 mx-4">
          <div className="bg-white/10 rounded-full px-4 py-1.5 flex items-center gap-2">
            <Search className="w-4 h-4 text-white/50" />
            <span className="text-white/50 text-sm">Search privately...</span>
          </div>
        </div>
      </div>

      {/* Content area */}
      <div className="p-4">
        {/* Search results context */}
        <div className="text-xs text-white/40 mb-3">Sponsored Result</div>

        {/* Ad container */}
        <div
          className="rounded-lg overflow-hidden bg-[#1a1f2e]"
          style={{ maxWidth: isLeaderboard ? '100%' : isSidebar ? '200px' : '100%' }}
        >
          {children}
        </div>

        {/* Fake organic results below */}
        <div className="mt-4 space-y-3">
          <div className="flex items-start gap-3 p-3 rounded-lg bg-white/5">
            <div className="w-10 h-10 rounded bg-white/10 flex-shrink-0" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3 bg-white/20 rounded w-3/4" />
              <div className="h-2 bg-white/10 rounded w-full" />
              <div className="h-2 bg-white/10 rounded w-5/6" />
            </div>
          </div>
          <div className="flex items-start gap-3 p-3 rounded-lg bg-white/5">
            <div className="w-10 h-10 rounded bg-white/10 flex-shrink-0" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3 bg-white/20 rounded w-2/3" />
              <div className="h-2 bg-white/10 rounded w-full" />
              <div className="h-2 bg-white/10 rounded w-4/5" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
